import { action, computed, makeObservable, observable } from 'mobx'

import { DTO } from '../DTO'
import { WorkbookPageProblemColl } from './WorkbookPageProblemColl'

export class WorkbookPage extends DTO {
  id = -1
  page = -1
  title = ''
  workbookId = -1
  pageProblemColl?: WorkbookPageProblemColl

  constructor(data: Partial<WorkbookPage>) {
    super()
    Object.assign(this, {
      ...data,
      pageProblemColl: data.pageProblemColl
        ? new WorkbookPageProblemColl(data.pageProblemColl.toArr)
        : undefined,
    })

    makeObservable(this, {
      id: observable,
      page: observable,
      title: observable,
      workbookId: observable,
      pageProblemColl: observable,
      // imageUrl: observable,
      isSomeChecked: computed,
      isAllChecked: computed,
      allCheck: action,
      clearAllCheck: action,
      toggleAllCheck: action,
    })
  }

  get isSomeChecked() {
    return this.pageProblemColl?.isSomeChecked
  }

  get isAllChecked() {
    return this.pageProblemColl?.isFullyChecked
  }

  allCheck() {
    this.pageProblemColl?.allCheck()
  }

  clearAllCheck() {
    this.pageProblemColl?.clearAllcheck()
  }

  toggleAllCheck() {
    if (this.isAllChecked) {
      this.clearAllCheck()
    } else {
      this.allCheck()
    }
  }
}
